<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  HASH NOTARIAL
                  <span>Tecnología NOTIN       </span>
                </h1>
                <p class="lead  text-white">
                  Optimización digital del  ACTA de TRANSPARENCIA
                </p>
                <div class="btn-wrapper">
                  <!-- <p class="lead text-white">
                    This web app can be generated in Vue.js combined with
                    Express / Flask or Laravel. Your choice :)
                  </p> -->
                  <a
                    target="_blank"
                    href="#"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                    v-scroll-to="'#contacto'"
                  >
                    <i style="color: red" class="fa fa-rocket"></i>
                    <span class="btn-inner--text"
                      >Solicitar Demo</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
  <div class="profile-page">
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img
                      v-lazy="'img/brand/squareN.png'"
                      class="rounded-circle rounded-notin"
                    />
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                <!-- <div class="card-profile-actions py-4 mt-lg-0">
                  <base-button type="info" size="sm" class="mr-4"
                    >Connect</base-button
                  >
                  <base-button type="default" size="sm" class="float-right"
                    >Message</base-button
                  >
                </div> -->
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
                  <!-- <div>
                    <span class="heading">22</span>
                    <span class="description">Friends</span>
                  </div>
                  <div>
                    <span class="heading">10</span>
                    <span class="description">Photos</span>
                  </div>
                  <div>
                    <span class="heading">89</span>
                    <span class="description">Comments</span>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-lg-12 text-center mt-5"><br><br><br>
                    <h3>
                        Aplicación de la tecnología HASH en el Acta de Transparencia
                        
                    </h3>
                    <!-- <div class="h6 font-weight-300">
                        <i class="ni location_pin mr-2"></i>Bucharest, Romania
                    </div>
                    <div class="h6 mt-4">
                        <i class="ni business_briefcase-24 mr-2"></i>Solution Manager -
                        Creative Tim Officer
                    </div>
                    <div>
                        <i class="ni education_hat mr-2"></i>University of Computer
                        Science
                    </div> -->
                </div>
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <p>
                    Es posible <strong>reducir los costes inherentes al acta de transparencia</strong> material, en particular los de manipulación, impresión, encuadernación y conservación del protocolo, incorporando únicamente en el documento la referencia HASH del fichero que contiene todo el expediente LCCI.
                  </p>
                  <p>
                    Además de la <strong>limpieza y la agilidad que ofrece la autorización con HASH</strong>, disponemos de un sistema digital híbrido que por un lado encripta el expediente LCCI y por otro permite añadir posteriormente el “test” como documento unido. Es la primera de las nuevas herramientas de tratamiento digital necesarias en el sector notarial.
                  </p>
                  <!-- <a href="#">Show more</a> -->
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
    <section class="section section-lg pt-lg-0 ">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
              <h2 class="display-3 text-center">¿Cómo lo hacemos?</h2>
            <div class="row row-grid mt-5">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-check-bold"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Creación</h6>
                  <p class="description mt-3">
                    NOTIN incorpora, en su sistema de gestión LCCI, con un simple botón, la creación instantánea del fichero electrónico HASH que contiene la documentación <strong>descargada de la plataforma y añade el texto en la matriz</strong> indicando la existencia del fichero y su clave HASH.
                  </p>
                  <div>
                    <badge type="primary" rounded>documentación</badge>
                    <badge type="primary" rounded>descargas</badge>
                    <badge type="primary" rounded>texto</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="primary" class="mt-4">
                    Demostración
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-cloud-upload-96"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Conservación</h6>
                  <p class="description mt-3">
                    La <strong>conservación del fichero HASH durante toda la vida del préstamo</strong> queda garantizada localmente por su almacenamiento en la carpeta de matrices de la Notaría y universalmente en el repositorio REETRO de NOTIN durante 50 años.
                  </p>
                  <div>
                    <badge type="success" rounded>seguridad</badge>
                    <badge type="success" rounded>copia</badge>
                    <badge type="success" rounded>online</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="success" class="mt-4">
                    Demostración
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="ni ni-paper-diploma" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Consulta</h6>
                  <p class="description mt-3">
                    Desde NOTIN, el usuario dispone de la opción de consultar el fichero HASH en cualquier momento para validar su contenido. Las imágenes íntegras del directorio digital serán incluidas en cualquier copia que realice la Notaría.
                  </p>
                  <div>
                    <badge type="warning" rounded>visualizar</badge>
                    <badge type="warning" rounded>contenido</badge>
                    <badge type="warning" rounded>imágenes</badge>
                  </div>
                  <base-button tag="a" href="#" v-scroll-to="'#contacto'" type="warning" class="mt-4">
                    demostración
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12 mt-5">
              <card class="border-0" shadow body-classes="py-5">
              <h5 class=" text-center">
                La generación directa del fichero HASH es una de las diez funcionalidades del ecosistema de Gestión LCCI que integra el archivo del expediente digital de la operación, creación del ACTA, interpretación del proyecto, comprobación de FEIN, comprobación el RGCG y cierre de hipoteca.
              </h5>
              </card>
          </div>
        </div>
      </div>
    </section>
    

    <section class="section section-shaped my-0 overflow-hidden bg-gris">
      <div class="shape shape-style-3 bg-gradient-hash shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container  pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Información Útil</h2>
            <p class="lead text-white text-justify">
              La viabilidad de esta forma de archivo se deriva, por otra parte, del <strong>art. 114.1 de la Ley 24/2001</strong>.              
              Dicha norma sería desarrollada posteriormente mediante el art. 216 del Reglamento Notarial.
            </p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-6">
            <icon
              name="ni ni-book-bookmark"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <p class="text-white mt-3">
              <a class="text-white text-underline text-bold" href="https://www.boe.es/buscar/act.php?id=BOE-A-2010-1331" target="_blank">Real Decreto 4/2010, de 8 de enero, por el que se regula el Esquema Nacional de Interoperabilidad en el ámbito de la Administración Electrónica</a>
            </p>
          </div>
          <div class="col-lg-6">
           <icon
              name="ni ni-book-bookmark"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <p class="text-white mt-3">
              <a class="text-white text-underline text-bold" href="https://www.boe.es/buscar/act.php?id=BOE-A-2011-13169" target="_blank">Resolución de 19 de julio de 2011, de la Secretaría de Estado para la Función Pública, por la que se aprueba la Norma Técnica de Interoperabilidad de Documento Electrónico.</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: "hash",


};
</script>
<style scoped>

</style>